import styled from 'styled-components'
import { h } from 'preact'
import dateformat from 'dateformat'

import { JobType, ImageVersionType, CompanyType, PlaceType } from '../reducers'
import { companyLogoSizes } from '../reducers/mediaItems'
import { media } from '../styled/mixins'
import { jobUrl } from '../helpers/url'
import { jobLocality } from '../helpers/jobs'

import CompanyLogo from './CompanyLogo'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  box-shadow: 0 0 5px rgba(239, 239, 239, 1);
  margin-top: 18px;
  box-sizing: border-box;
  overflow: hidden;
  ${media.phone`
    display: block;
    padding: 20px 16px;
  `}
  ${CompanyLogo} {
    width: 56px;
  }
`

const Cell = styled.div`
  vertical-align: middle;
  padding: 15px;
  flex: 0 auto;
  ${media.phone`
    display: block;
    padding: 0;
  `}
`

const Link = styled.a`
  text-decoration: none !important;
`

const TitleLink = Link.extend`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #1F313A;
  ${media.phone`
    font-size: 16px;
    line-height: 22px;
  `}
`

const MainCell = Cell.extend`
  flex: 1;
  overflow: hidden;
  ${TitleLink} {
    white-space: nowrap;
    overflow: hidden;
    ${media.phone`
      white-space: normal;
    `}
  }
`

const LogoCell = Cell.extend`
  text-align: center;
  padding-left: 30px;
  ${media.tablet`
    width: 56px;
  `}
  ${media.phone`
    padding: 0;
    margin-bottom: 20px;
  `}
`

const Company = styled.div`
  color: #DCE4E7;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin: 5px 0;
`

const Data = styled.div`
  color: #B3BFC4;
  font-size: 12px;
  line-height: 16px;
`

const Type = styled.span`
  display: inline-block;
  border-right: 1px solid #B3BFC4;
  padding-right: 13px;
  margin-right: 13px;
  ${media.phone`
    border-right: none;
    padding-right: 0;
  `}
`

const IconLabel = styled.i`
  margin-right: 13px;
  &:before {
    margin-right: 5px;
  }
`

const IconDeadline = IconLabel.extend`
  color: #ff2d55;
`

const ArrowCell = Cell.extend`
  text-align: right;
  ${media.phone`
    display: none;
  `}
`

const ArrowLink = Link.extend`
  color: #B3BFC4;
  font-size: 20px;
  &:hover {
    text-decoration: none;
    color: #1F313A;
  }
`

const JobTile = ({ job, logo, company, place }) => (
  <Wrapper>
    <LogoCell>
      <CompanyLogo imageItem={logo} versionType={companyLogoSizes.LARGE} />
    </LogoCell>
    <MainCell>
      <TitleLink href={jobUrl(job.id, company.domain)} target="_blank">
        {job.title}
      </TitleLink>
      <Company>{company.name}</Company>
      <Data>
        <Type>{job.employmentType.name}</Type>
        <IconLabel className="jw-icon-location">{jobLocality(job, place)}</IconLabel>
        {job.deadline && (
          <IconDeadline className="jw-icon-calendar">
            {dateformat(job.deadline, 'mmmm dd, yyyy')}
          </IconDeadline>
        )}
      </Data>
    </MainCell>
    <ArrowCell>
      <ArrowLink href={jobUrl(job.id, company.domain)} target="_blank">
        <i className="jw-icon-right-arrow" />
      </ArrowLink>
    </ArrowCell>
  </Wrapper>
)

JobTile.propTypes = {
  job: JobType.isRequired,
  logo: ImageVersionType,
  company: CompanyType.isRequired,
  place: PlaceType
}

JobTile.defaultProps = {
  logo: null,
  place: null
}

export default JobTile



// WEBPACK FOOTER //
// ./src/components/JobTile.js